export default __webpack_public_path__ + "static/media/login register-04.35c5e19a.png";